import { has } from 'lodash';

/**
 * Active ranges
 */
export type TimeRangeOption =
  | 'lastFiveMinutes'
  | 'lastHour'
  | 'lastFourHours'
  | 'lastDay'
  | 'lastThreeDays'
  | 'lastWeek'
  | 'lastMonth'
  | 'lastThreeMonths'
  | 'custom';

export type FastModeRange = 'lastMonth' | 'lastThreeMonths';

export const timeRangeOptionLabels = {
  lastFiveMinutes: 'Last five minutes',
  lastHour: 'Last hour',
  lastFourHours: 'Last four hours',
  lastDay: 'Last day',
  lastThreeDays: 'Last three days',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  lastThreeMonths: 'Last three months',
  custom: 'Custom...',
};

export type RangeSelectedFn = (
  selectedRange: TimeRangeOption,
  fromISOString?: string,
  toISOSTring?: string,
  selectedFastModeRange?: FastModeRange,
) => void;

export const defaultTimeRange = 'lastDay';

export function printTimeRangeLabel(
  range: TimeRangeOption,
  customLabels?: Partial<Record<TimeRangeOption, string>>,
): string {
  if (!timeRangeOptionLabels[range]) {
    throw new Error(`expected a valid time range, received: ${range}`);
  }
  return customLabels && has(customLabels, range)
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      customLabels[range]!!
    : timeRangeOptionLabels[range];
}
